import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaExpand, FaCompress } from 'react-icons/fa';
import '../styles.css';

const PdfViewer = () => {
  const { unique_username, name } = useParams();
  const navigate = useNavigate();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const pdfViewerRef = useRef(null);
  
  // Construct the correct file path
  const pdfUrl = `https://dev.invoge.com/backend/uploads/${unique_username}/${name}`;
  
  // Detect if the user is on a mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Validate the required parameters
  useEffect(() => {
    if (!unique_username || !name) {
      alert('Invalid PDF details. Redirecting to home...');
      navigate('/');
    }
  }, [unique_username, name, navigate]);

  // Toggle Full-Screen Mode
  const toggleFullScreen = () => {
    if (!isFullScreen) {
      if (pdfViewerRef.current.requestFullscreen) {
        pdfViewerRef.current.requestFullscreen();
      } else if (pdfViewerRef.current.mozRequestFullScreen) {
        pdfViewerRef.current.mozRequestFullScreen();
      } else if (pdfViewerRef.current.webkitRequestFullscreen) {
        pdfViewerRef.current.webkitRequestFullscreen();
      } else if (pdfViewerRef.current.msRequestFullscreen) {
        pdfViewerRef.current.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    setIsFullScreen(!isFullScreen);
  };

  return (
    <div className={`pdf-container ${isFullScreen ? 'fullscreen' : ''}`} ref={pdfViewerRef}>
      {/* Fullscreen Button */}
      <button className="fullscreen-btn" onClick={toggleFullScreen}>
        {isFullScreen ? <FaCompress /> : <FaExpand />} {isFullScreen ? 'Exit Fullscreen' : 'Fullscreen'}
      </button>

      {/* PDF Viewer: Use Google's Viewer as fallback for mobile */}
      {unique_username && name ? (
        isMobile ? (
          <iframe
            src={`https://docs.google.com/gview?url=${pdfUrl}&embedded=true`}
            className="pdf-viewer"
            aria-label="PDF Viewer"
          ></iframe>
        ) : (
          <embed
            src={pdfUrl}
            type="application/pdf"
            className="pdf-viewer"
            aria-label="PDF Viewer"
          />
        )
      ) : (
        <p>Invalid or missing PDF details.</p>
      )}
    </div>
  );
};

export default PdfViewer;
